// extracted by mini-css-extract-plugin
export default {"add":"control_add__lO+s3","tooltip":"control_tooltip__K3wFI"};